import { render, staticRenderFns } from "./Questionasked.vue?vue&type=template&id=039a4396&scoped=true"
import script from "./Questionasked.vue?vue&type=script&lang=js"
export * from "./Questionasked.vue?vue&type=script&lang=js"
import style0 from "./Questionasked.vue?vue&type=style&index=0&id=039a4396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039a4396",
  null
  
)

export default component.exports